import { useEffect, useState } from "react"
import { ForumForm, ForumMessage, Loading, getForumMessages, TForumMessage, Section, Heading, EMessageType } from '@sifrovacihra/shared-ui'
import { useAction } from "../../store"

export const Forum = () => {
    const forum = 'main'
    const [messages, setMessages] = useState<TForumMessage[]>([])
    const [loading, setLoading] = useState(false)
    const { setInfoMessageAction } = useAction()

    useEffect(() => {
        getMessages()
    }, [])

    const getMessages = () => {
        setLoading(true)
        getForumMessages({ forum: forum }).then((res) => {
            if (res.messages) {
                setMessages(res.messages)
            }
        }).finally(() => {
            setLoading(false)
        })
    }

    return (
        <>
            <Heading headline='Diskuze' weight={1} />
            <Section>
                <ForumForm
                    forum={forum}
                    onReload={getMessages}
                    onSuccess={msg => setInfoMessageAction({ type: EMessageType.SUCCESS, message: msg })}
                    onError={msg => setInfoMessageAction({ type: EMessageType.ERROR, message: msg })}
                />
            </Section>
            <Section>
                <>
                    {loading ? <Loading /> : ''}
                    {messages.map((m) => <ForumMessage message={m} />)}
                </>
            </Section>
        </>
    )
}
